import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsSubsidizedMortgage = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_subsidised_mortgage')(jsonQuery),
);
